// (c) chaehongee. Confidential and proprietary.

import type { RootState } from '../store'
import { selectActiveSessionId } from './sessionSelectors'
import type { SelectionState } from '../slices/selectionSlice'

const EMPTY_SELECTED_NODE_IDS: string[] = []

const EMPTY_SELECTION_STATE: SelectionState = {
    selectedNodeIds: EMPTY_SELECTED_NODE_IDS,
    hoveredNodeId: null,
    previewImageUrl: null,
    brushEnabled: false,
    hasMaskStrokes: false,
    pendingInitialSelectionId: null,
}

export function selectSelectionBySessionId(
    state: RootState,
    sessionId: string
): SelectionState {
    return state.selection.bySessionId[sessionId] ?? EMPTY_SELECTION_STATE
}

export function selectSelectedNodeIdsBySessionId(
    state: RootState,
    sessionId: string
): string[] {
    return state.selection.bySessionId[sessionId]?.selectedNodeIds ?? EMPTY_SELECTED_NODE_IDS
}

export function selectActiveSelection(state: RootState): SelectionState {
    const id = selectActiveSessionId(state)
    return id ? selectSelectionBySessionId(state, id) : EMPTY_SELECTION_STATE
}

export function selectPendingInitialSelectionIdBySessionId(
    state: RootState,
    sessionId: string
): string | null {
    return state.selection.bySessionId[sessionId]?.pendingInitialSelectionId ?? null
}

export function selectHoveredNodeIdBySessionId(
    state: RootState,
    sessionId: string
): string | null {
    return state.selection.bySessionId[sessionId]?.hoveredNodeId ?? null
}

export function selectPreviewImageUrlBySessionId(
    state: RootState,
    sessionId: string
): string | null {
    return state.selection.bySessionId[sessionId]?.previewImageUrl ?? null
}

export function selectBrushEnabledBySessionId(
    state: RootState,
    sessionId: string
): boolean {
    return Boolean(state.selection.bySessionId[sessionId]?.brushEnabled)
}

export function selectHasMaskStrokesBySessionId(
    state: RootState,
    sessionId: string
): boolean {
    return Boolean(state.selection.bySessionId[sessionId]?.hasMaskStrokes)
}

export function selectActiveSelectedNodeIds(state: RootState): string[] {
    const id = selectActiveSessionId(state)
    return id ? selectSelectedNodeIdsBySessionId(state, id) : EMPTY_SELECTED_NODE_IDS
}

export function selectActivePendingInitialSelectionId(state: RootState): string | null {
    const id = selectActiveSessionId(state)
    return id ? selectPendingInitialSelectionIdBySessionId(state, id) : null
}

export function selectActiveHoveredNodeId(state: RootState): string | null {
    const id = selectActiveSessionId(state)
    return id ? selectHoveredNodeIdBySessionId(state, id) : null
}

export function selectActivePreviewImageUrl(state: RootState): string | null {
    const id = selectActiveSessionId(state)
    return id ? selectPreviewImageUrlBySessionId(state, id) : null
}

export function selectActiveBrushEnabled(state: RootState): boolean {
    const id = selectActiveSessionId(state)
    return id ? selectBrushEnabledBySessionId(state, id) : false
}

export function selectActiveHasMaskStrokes(state: RootState): boolean {
    const id = selectActiveSessionId(state)
    return id ? selectHasMaskStrokesBySessionId(state, id) : false
}

